module.exports = __webpack_public_path__ + "static/media/so-stock--sheep1.9b502be1.jpg";